<template>
  <div class="clearfix main_center">
    <div class="right-content clearfix busWinessRight">
      <el-card class="box-card" style="margin-bottom: 10px">
        <div slot="header" class="clearfix">
          <span>评标记录</span>
        </div>
        <el-form label-width="200px" style="display: flex; flex-wrap: wrap; justify-content: space-between">
          <el-form-item class="double-row" label="标段名称：">
            <span>{{ detail.tenderProjectName }}</span>
          </el-form-item>
          <el-form-item class="double-row" label="评标方式：">
            <span>{{ detail.tenderprojectCode }}</span>
          </el-form-item>
          <el-form-item class="double-row" label="评标时间：">
            <span>评标</span>
          </el-form-item>
          <el-form-item class="double-row" label="投标单位名称：">
            <span>{{ detail.tenderProjectName }}</span>
          </el-form-item>
          <el-form-item class="double-row" label="排名/推荐：">
            <span>{{ detail.tenderprojectCode }}</span>
          </el-form-item>
          <el-form-item class="double-row" label="评分结果：">
            <span>评标</span>
          </el-form-item>
        </el-form>
      </el-card>
      <!-- 权限控制-->
      <el-card class="box-card" style="margin-bottom: 10px">
        <div slot="header" class="clearfix">
          <span>投标人列表</span>
        </div>
        <el-table :data="auditHisTable" stripe border style="width: 100%">
          <el-table-column type="index" header-align="center" align="center" label="序号" width="80"> </el-table-column>
          <el-table-column prop="taskName" align="left" :show-overflow-tooltip="true" min-width="200" label="投标人"> </el-table-column>
          <el-table-column prop="userName" align="left" :show-overflow-tooltip="true" width="250" label="排名"> </el-table-column>
          <el-table-column prop="excuteDate" align="center" width="250" label="评分结果"> </el-table-column>
        </el-table>
      </el-card>

      <!-- 附件数据 -->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>附件列表</span>
        </div>
        <template>
          <div class="affixDown" v-if="attachmentList.length > 0" style="margin-bottom: 10px" v-loading="refreshLoading">
            <affixDoc
              v-for="(item, index) in attachmentList"
              :item.sync="item"
              labelWidth="200px"
              :index="index"
              :key="index"
              :entityId="entityId"
              :filingCBtn="IsShow(item) && filingCBtn"
              :showModal="false"
              :name="item.titleName"
            >
            </affixDoc>
          </div>
          <p style="text-align: center" v-if="attachmentList.length == 0">暂无附件数据</p>
        </template>
      </el-card>
    </div>

    <div class="left-content busWinessLeft">
      <div class="left-navbar">
        <el-button @click="back()" size="small">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import affixDoc from "@/components/affixDoc";

export default {
  components: {
    affixDoc,
  },
  data() {
    return {
      auditForm: {
        mark: "",
        isPass: false,
      },
      dialogVisible: false,
      detail: {
        resultList: [],
        tendersList: [],
      },
      platformCode: "",
      pubServicePlatCode: "",
      filingCBtn: false,
      backCBtn: false,
      auditHisTable: [],
      // 专家查看权限状态：0，01待申请02待授权03已授权04已拒绝
      expertStatus: "0",
      // 项目是否抽取完成
      projectIsFinish: "1",
      isExpert: false,
      id: "",
      applyInfo: {},
      printData: {
        noCode: "",
      },
      entityId: "",
      refreshLoading: false,
      attachmentList: [],
    };
  },
  methods: {
    IsShow(item) {
      var mark = item.attributes;
      if (mark && mark.showSignBtn) {
        return true;
      }
      return false;
    },

    getDetail() {
      this.$http.post(`/expertController/getExpertExtractionByEntityId?entityId=${this.id}`).then((res) => {
        const { code, data } = res.data;
        if (code == 1) {
          this.detail = data;
        }
      });
    },
    back() {
      this.$router.go(-1);
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.processinstanceid = this.$route.query.processinstanceid;
    this.isExpert = this.$route.query.type === "expert"; // expert || business
    this.tenderCode = this.$route.query.tenderCode;
    this.getDetail();
  },
};
</script>
<style lang="less" scoped>
.el-form /deep/ .el-form-item.double-row {
  width: 50%;
}

.right-content.busWinessRight {
  width: calc(100% - 160px);
}

.left-content.busWinessLeft {
  .left-navbar {
    width: 150px;
    border: none;
  }
}

</style>
